<template>
  <div id="editarPlanificacionAnualCharter">
    <ui-modal ref="modal" :title="`Editar planificación anual de ${title}`" @close="ActionSetVisibleModalEditar(false)" class="modal-actualizar-cliente">

      <div style="height: 70vh">

        <!-- Header -->
          <div class="d-flex flex-column w-100">

            <!-- Información adicional / Botones de accionamiento -->
            <div class="d-flex">

              <!-- Información -->
              <div class="d-flex w-100">

                <div class="d-flex mr-3">
                  <div class="mr-1"><b>Año: </b></div>
                  <div v-text="anio"></div>
                </div>

                <div class="d-flex mr-3">
                  <div class="mr-1"><b>Empresa: </b></div>
                  <div v-text="cliente"></div>
                </div>

                <div class="d-flex">
                  <div class="mr-1"><b>Total anual planificado: </b></div>
                  <div v-text="totalAnual"></div>
                </div>
              </div>

              <!-- Botones -->
              <div class="d-flex">

                <Button
                  title="Agregar puerto destino"
                  :size="15"
                  color="#2087c3"
                  colorText="#ffffff"
                  icon="fas fa-ship"
                  :width="35"
                  round
                  @click.native="activeAgregarFila = !activeAgregarFila"
                  traslate
                  :active="activeAgregarFila"
                  :traslateSelected="activeAgregarFila"
                  class="mr-2"
                />

                <actualizar-planificacion-anual-regiones-modal :semanasDelAnio="semanasDelAnio" />

                <eliminacion-multiple-modal />

              </div>

            </div>

            <!-- Agregar fila -->
            <div v-if="activeAgregarFila" class="d-flex align-items-center">

              <!-- Servicio -->
                <ui-select
                  class="w-100 mt-3 ml-2"
                  label="Región"
                  hasSearch
                  searchPlaceholder="Buscar región"
                  placeholder="- Seleccionar -"
                  :options="listaRegiones"
                  v-model="regionModel"
                  @change="validarFormulario"
                  :keys="{ value: 'id', label: 'name' }"
                />

              <!-- Botones para Agregar Planificación -->
                <!-- Activo -->
                <Button
                  title="Agregar servicio"
                  :size="15"
                  color="#2da44e"
                  colorText="#ffffff"
                  icon="fas fa-plus"
                  :width="35"
                  round
                  class="ml-3"
                  v-if="botonAddFormularioActivo"
                  @click.native="agregarFila()"
                />

                <!-- Inactivo -->
                <div v-else class="d-flex align-items-center justify-content-center ml-3" title="Agregar servicio" style="width: 35px; height: 35px; border: 1px solid grey; border-radius: 100px; padding: 10px;">
                  <i class="fas fa-plus" style="color: grey; font-size: 15px"></i>
                </div>

            </div>

          </div>

        <!-- Body -->

          <!-- Tabs -->
          <!-- <ui-tabs fullwidth raised disableRipple class="mt-2" v-if="showTabs"> -->
          <ui-tabs fullwidth raised disableRipple class="mt-2" >
              <ui-tab key="informacion1" title="Semanas 1 a 13">
                  <informacion-general-planificacion-anual-charter-tabs :data="primerTabDataAux" :headers="hadersPrimerTab" :totales="primerTabSumaColumna" :id_tab="1" :totalPeriodo="primerTabTotalAnual" :semanas="semanasDelAnio"/>
              </ui-tab>

              <ui-tab key="informacion2" title="Semanas 14 a 26">
                  <informacion-general-planificacion-anual-charter-tabs :data="segundoTabDataAux" :headers="hadersSegundoTab" :totales="segundoTabSumaColumna" :id_tab="2" :totalPeriodo="segundoTabTotalAnual" :semanas="semanasDelAnio"/>
              </ui-tab>

              <ui-tab key="informacion3" title="Semanas 27 a 39">
                  <informacion-general-planificacion-anual-charter-tabs :data="tercerTabDataAux" :headers="hadersTercerTab" :totales="tercerTabSumaColumna" :id_tab="3" :totalPeriodo="tercerTabTotalAnual" :semanas="semanasDelAnio"/>
              </ui-tab>

              <ui-tab key="informacion4" :title="`Semanas 40 a ${semanasDelAnio}`">
                  <informacion-general-planificacion-anual-charter-tabs :data="cuartoTabDataAux" :headers="hadersCuartoTab" :totales="cuartoTabSumaColumna" :id_tab="4" :totalPeriodo="cuartoTabTotalAnual" :semanas="semanasDelAnio"/>
              </ui-tab>
          </ui-tabs>
        
      </div>

    </ui-modal>
  </div>
</template>

<script>

  // Vue
  import Vue from "vue";

  // Moment
  import moment from "moment";

  // VUEX
  import { mapActions, mapState } from "vuex";

  // Animated
  import VAnimateCss from "v-animate-css";
  Vue.use(VAnimateCss);

  // Toast
  import VueToastify from "vue-toastify";
  Vue.use(VueToastify);

  

  // UI Modal
  import UiModal from "keen-ui/src/UiModal";
  import UiTabs from "keen-ui/src/UiTabs";
  import UiTab from "keen-ui/src/UiTab";

  import Button from "../../../common/Button.vue";
  import InformacionGeneralPlanificacionAnualCharterTabs from '../../../tabs/charter/planificacionAnualDetalleTabs/InformacionGeneralPlanificacionAnualCharterTabs.vue';
  import ActualizarPlanificacionAnualRegionesModal from './ActualizarPlanificacionAnualRegionesModal.vue';
  import EliminacionMultipleModal from './EliminacionMultipleModal.vue';

  export default {
    props: ["Titulo", "dataAux", "semanas","index_selected"],

    data() {
      return {
        title                        : "",
        anioModel                    : [],
        palletModel                  : {},
        regionModel                  : [],
        clienteModel                 : {},
        servicioModel                : {},
        botonAddFormularioActivo     : false,
        data                         : [],
        left                         : 300,
        semanasEstructura            : [],
        valorTotalVertical           : 0, // Valor suma vertical de todos los totales horizontales
        valorTotalVerticalPorColumna : [], // Valor suma vertical de todas las columnas
        desactivarBtnFiltrar         : false,
        semanasDelAnio               : 0,

        totalAnual                   : 0,
        anio                         : 0,
        cliente                      : 0,

        // Tab 1
        primerTabDataAux             : [],
        primerTabTotalAnual          : 0,
        hadersPrimerTab              : [
            '*',
            'Región',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            'Total',
            'Opciones',
        ],
        primerTabSumaColumna         : [],

        // Tab 2
        segundoTabDataAux            : [],
        segundoTabTotalAnual         : 0,
        hadersSegundoTab             : [
            '*',
            'Región',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20',
            '21',
            '22',
            '23',
            '24',
            '25',
            '26',
            'Total',
            'Opciones',
        ],
        segundoTabSumaColumna        : [],


        // Tab 3
        tercerTabDataAux             : [],
        tercerTabTotalAnual          : 0,
        hadersTercerTab              : [
            '*',
            'Región',
            '27',
            '28',
            '29',
            '30',
            '31',
            '32',
            '33',
            '34',
            '35',
            '36',
            '37',
            '38',
            '39',
            'Total',
            'Opciones',
        ],
        tercerTabSumaColumna         : [],


        // Tab 4
        cuartoTabDataAux             : [],
        cuartoTabTotalAnual          : 0,
        hadersCuartoTab              : [],
        cuartoTabSumaColumna         : [],

        activeAgregarFila            : false,

        annual_plan_id               : '',
        puertosPlanificacion         : [],
        showTabs : true

      };
    },

    components: {
      UiModal,
      UiTabs,
      UiTab,
      Button,
      InformacionGeneralPlanificacionAnualCharterTabs,
      ActualizarPlanificacionAnualRegionesModal,
      EliminacionMultipleModal,
    },

    computed: {
      ...mapState(["visibleModalEditar", "listaPallets", "clientes", "usuarioActual"]),
      ...mapState("charter", ["listaPallet","dataAnioSeleccionado","annualPlanId", "listaRegiones"]),
    },

    methods: {

      ...mapActions(["ActionSetVisibleModalEditar"]),
      ...mapActions("charter", ["actionSetDataAnioSeleccionado", "actionResetDataAnioSeleccionado","actionSetNuevosPlanificacionAnualMultiples","actionSetAnnualPlanId"]),

      openModal(ref) {
        this.$refs[ref].open();
      },

      closeModal(ref) {
        this.$refs[ref].close();
      },

      validarFormulario() {

        if (Object.keys(this.regionModel).length) {
          this.botonAddFormularioActivo = true;
        } else {
          this.botonAddFormularioActivo = false;
        }

      },

      async agregarFila() {

          let dataAnioSeleccionadoTemp = this.dataAnioSeleccionado;

          let semanas = [];
          let valorSemana = [];

          for (let i = 0; i <= this.semanasDelAnio; i++) {
              semanas.push({annual_qty: 0});
              valorSemana.push(0);
          }

          const pallet_id = await this.dataAux.data_complementaria.pallet_selected.id;

          let dataTemp = await {
              id   : this.dataAnioSeleccionado.length + this.primerTabDataAux.length,
              data : [this.regionModel.name].concat(valorSemana),
              data_complementaria : {
                  annual_plan_id     : this.annualPlanId,
                  total              : 0,
                  weeks              : semanas,
                  id_pallet          : pallet_id,
                  route_id           : this.regionModel.id

              },

              new : true,
          }

          dataAnioSeleccionadoTemp.push(dataTemp);

          this.actionSetDataAnioSeleccionado(dataAnioSeleccionadoTemp);
          dataAnioSeleccionadoTemp = [];

          let id = parseInt(this.consolidadoTabDataAux.length);

          this.actionSetNuevosPlanificacionAnualMultiples({'index':id, "regiones": this.regionModel});

      },

      async cargarDataAnioSeleccionado(_new){

        if (_new) {
          
          const { data_complementaria   }  = _new;
          const { routes, annual_plan_id } = data_complementaria;

          const id_plan_anual = annual_plan_id;

          let anioSeleccionado = _new.data[0].toString();

          this.anio       = _new.data[0];
          this.cliente    = _new.data[1];
          this.totalAnual = _new.data[3];

          if(moment(anioSeleccionado).isLeapYear()){

              this.semanasDelAnio = 53;
              this.hadersCuartoTab = [
                  '*',
                  'Región',
                  '40',
                  '41',
                  '42',
                  '43',
                  '44',
                  '45',
                  '46',
                  '47',
                  '48',
                  '49',
                  '50',
                  '51',
                  '52',
                  '53',
                  'Total',
                  'Opciones',
              ];

          }else{

              this.semanasDelAnio = 52;
              this.hadersCuartoTab = [
                  '*',
                  'Región',
                  '40',
                  '41',
                  '42',
                  '43',
                  '44',
                  '45',
                  '46',
                  '47',
                  '48',
                  '49',
                  '50',
                  '51',
                  '52',
                  'Total',
                  'Opciones',
              ];

          }

          this.actionSetAnnualPlanId(id_plan_anual)

          this.SegmentacionTabs(routes, id_plan_anual);

        }

      },
      
      SegmentacionTabs(data, annual_plan_id){

        const id_plan_anual = annual_plan_id;

        let weeksKeys                 = [];
        let consolidadoTabData        = [];
        let primerTabData             = [];
        let segundoTabData            = [];
        let tercerTabData             = [];
        let cuartoTabData             = [];

        let primerTab                 = [];
        let primerTabTotal            = 0;
        let primerTabTotalAnual       = 0;
        let primerTabDetalle          = [];

        let segundoTab                = [];
        let segundoTabTotal           = 0;
        let segundoTabTotalAnual      = 0;
        let segundoTabDetalle         = [];

        let tercerTab                 = [];
        let tercerTabTotal            = 0;
        let tercerTabTotalAnual       = 0;
        let tercerTabDetalle          = [];

        let cuartoTab                 = [];
        let cuartoTabTotal            = 0;
        let cuartoTabTotalAnual       = 0;
        let cuartoTabDetalle          = [];

        let cargaAnualTotal           = 0;
        let cargaAnual                = 0;

        let semanasDataComplementaria = [];
        this.puertosPlanificacion     = [];

        let semanasTemp = [];

        data.map( (item, index_data) => {
            
            let cargaAnualPuerto = 0;

            const { pallet_id, weeks, route, route_id} = item;

            weeks.forEach( element => weeksKeys[element.week] = element );

            semanasTemp.push(weeksKeys);
            weeksKeys = [];

            for (let index = 1; index <= this.semanasDelAnio; index++) {

                if (index <= 13) {

                    if(semanasTemp[index_data][index]){

                        primerTab.push(semanasTemp[index_data][index].annual_qty);

                        cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                        primerTabTotal += semanasTemp[index_data][index].annual_qty;

                        semanasDataComplementaria.push({
                            "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                            "id"                : semanasTemp[index_data][index].id,
                            "week"              : semanasTemp[index_data][index].week,
                            "annual_qty"        : semanasTemp[index_data][index].annual_qty
                        });

                    }else{
                        primerTab.push(0);
                        semanasDataComplementaria.push({ "annual_qty" :  0});
                    }
                    
                }else if(index >= 14 && index <= 26){
                    
                    if(semanasTemp[index_data][index]){

                        segundoTab.push(semanasTemp[index_data][index].annual_qty); 

                        cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                        segundoTabTotal  += semanasTemp[index_data][index].annual_qty;

                        semanasDataComplementaria.push({
                            "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                            "id"                : semanasTemp[index_data][index].id,
                            "week"              : semanasTemp[index_data][index].week,
                            "annual_qty"        : semanasTemp[index_data][index].annual_qty
                        });

                    }else{

                        segundoTab.push(0);
                        semanasDataComplementaria.push({ "annual_qty" :  0});

                    }

                }else if(index >= 27 && index <= 39){
                    
                    if(semanasTemp[index_data][index]){

                        tercerTab.push(semanasTemp[index_data][index].annual_qty);
                        
                        cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                        tercerTabTotal += semanasTemp[index_data][index].annual_qty;

                        semanasDataComplementaria.push({
                            "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                            "id"                : semanasTemp[index_data][index].id,
                            "week"              : semanasTemp[index_data][index].week,
                            "annual_qty"        : semanasTemp[index_data][index].annual_qty
                        });

                    }else{

                        tercerTab.push(0);
                        semanasDataComplementaria.push({ "annual_qty" :  0});

                    }

                }else if(index >= 40){
                    
                    if(semanasTemp[index_data][index]){

                        cuartoTab.push(semanasTemp[index_data][index].annual_qty);
                        
                        cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                        cuartoTabTotal += semanasTemp[index_data][index].annual_qty;

                        semanasDataComplementaria.push({
                            "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                            "id"                : semanasTemp[index_data][index].id,
                            "week"              : semanasTemp[index_data][index].week,
                            "annual_qty"        : semanasTemp[index_data][index].annual_qty
                        });

                    }else{

                        cuartoTab.push(0);
                        semanasDataComplementaria.push({ "annual_qty" :  0});

                    }

                }

                semanasTemp[index_data][index] && (cargaAnual += semanasTemp[index_data][index].annual_qty);

            }

            primerTabTotalAnual  += primerTabTotal;
            segundoTabTotalAnual += segundoTabTotal;
            tercerTabTotalAnual  += tercerTabTotal;
            cuartoTabTotalAnual  += cuartoTabTotal;  

            primerTabData.push( {id: pallet_id, data : [route].concat(primerTab, primerTabTotal) });
            segundoTabData.push({id: pallet_id, data : [route].concat(segundoTab, segundoTabTotal) });
            tercerTabData.push( {id: pallet_id, data : [route].concat(tercerTab, tercerTabTotal) });
            cuartoTabData.push( {id: pallet_id, data : [route].concat(cuartoTab, cuartoTabTotal) });

            primerTabTotal  = 0;
            segundoTabTotal = 0;
            tercerTabTotal  = 0;
            cuartoTabTotal  = 0;

            const id_pallet = this.dataAux.data_complementaria.pallet_selected.id;

            this.puertosPlanificacion.push({
                id   : index_data,
                data : [route, cargaAnualPuerto].concat(primerTab, segundoTab, tercerTab, cuartoTab),
                data_complementaria : { total: cargaAnualPuerto, weeks : semanasDataComplementaria, "annual_plan_id" : id_plan_anual, id_pallet, route_id},
                new : false
            });

            cargaAnualPuerto = 0;
            semanasDataComplementaria = [];

            primerTabDetalle.push(primerTab);
            segundoTabDetalle.push(segundoTab);
            tercerTabDetalle.push(tercerTab);
            cuartoTabDetalle.push(cuartoTab);

            primerTab  = [];
            segundoTab = [];
            tercerTab  = [];
            cuartoTab  = [];

        });


        this.actionSetDataAnioSeleccionado(this.puertosPlanificacion);
        
        this.consolidadoTabDataAux = consolidadoTabData;

        this.totalAnualAux         = cargaAnualTotal;

        this.primerTabDataAux      = primerTabData;
        this.primerTabTotalAnual   = primerTabTotalAnual;
        primerTabData              = [];

        this.segundoTabDataAux     = segundoTabData;
        this.segundoTabTotalAnual  = segundoTabTotalAnual;

        this.tercerTabDataAux      = tercerTabData;
        this.tercerTabTotalAnual   = tercerTabTotalAnual;

        this.cuartoTabDataAux      = cuartoTabData;
        this.cuartoTabTotalAnual   = cuartoTabTotalAnual;

        this.primerTabSumaColumna  = this.obtenerSumaPorColumna(primerTabDetalle);
        this.segundoTabSumaColumna = this.obtenerSumaPorColumna(segundoTabDetalle);
        this.tercerTabSumaColumna  = this.obtenerSumaPorColumna(tercerTabDetalle);
        this.cuartoTabSumaColumna  = this.obtenerSumaPorColumna(cuartoTabDetalle);

        this.showTabs = true;

      },

      obtenerSumaPorColumna(data){

          if(Object.keys(data).length == 0){
              return 0;
          }

          const weeks = Object.keys( data[0] ) ;
              
          let weekTotal = {} ;
          weeks.forEach( week => weekTotal[week] = 0 );
          
          for (const week of weeks ) {
              let weekTotalTemp = 0;
              const weekInt = +week ; // El simbolo + transforma un String a Int
              data.forEach( ptd => weekTotalTemp += +ptd[ weekInt ] );
              weekTotal[weekInt] = weekTotalTemp;
          }

          return weekTotal;

      },

    },

    watch: {

      visibleModalEditar: function (_new) {
        _new && this.openModal("modal");
      },

      dataAux: function (_new) {

        if(_new){

          this.actionResetDataAnioSeleccionado();
          this.title = `${_new.data[1]} / ${_new.data[0]}`;
          this.cargarDataAnioSeleccionado(_new);

        }

          

      },

    },

  };

</script>

<style>

  #editarPlanificacionAnualCharter .modal-actualizar-cliente .ui-modal__container {
    width: 70% !important;
    height: 80%;
  }

  /* Estilo Textbox */
  .ui-textbox__input {
    width: 100%;
  }

  .ui-textbox__input,
  .ui-textbox__textarea {
    text-align: center;
  }

  /* ################################ Estilos para estructura de tabla ################################ */
  /* Estilo general de la tabla */
  .table-cebra {
    border-top: solid 1px #ccc;
    border-spacing: 0;
  }

  /* color de fondo y texto de las cabeceras */
  .table-cebra thead th {
    background: #333;
    color: #fff;
  }

  /* Ancho, padding y texto centrado de cada celda */
  .table-cebra th,
  .table-cebra td {
    min-width: 150px;
    padding: 0.5rem;
    text-align: center;
  }

  /* Borde inferior del contenido interno de la tabla */
  .table-cebra td {
    border-bottom: 1px solid #ccc;
  }

  /* Agrega color cebra a las columnas impares que no son fijas*/
  .table-cebra tbody tr {
    background: #fff;
  }

  /* Agrega color cebra a las columnas pares que no son fijas*/
  .table-cebra tbody tr:nth-child(2n) {
    background: #f2f2f2;
  }

  /* Contenedor de tabla */
  .table-container {
    max-width: 100%;
    overflow-x: scroll;
    border-left: solid 1px #ccc;
    border-right: solid 1px #ccc;
  }

  /* Fija la columna 1 */
  .table-cebra .sticky_cabecera_1 {
    position: sticky;
    left: 0;
    top: 0;
  }

  /* Fija la columna 2 */
  .table-cebra .sticky_cabecera_2 {
    position: sticky;
    left: 150px;
    top: 0;
  }

  /* Color de fondo para columnas fijas */
  .table-cebra tbody tr .sticky_cabecera_1,
  .sticky_cabecera_2 {
    background: #fff;
  }

  .table-cebra thead tr .sticky_cabecera_1 {
    position: sticky;
    top: 0;
    left: 0;
  }

  .table-cebra thead th {
    position: fixed;
  }

  /* Agrega color cebra a las columnas fijas*/
  .table-cebra tbody tr:nth-child(2n) .sticky_cabecera_1 {
    background: #f2f2f2;
  }

  .table-cebra tbody tr:nth-child(2n) .sticky_cabecera_2 {
    background: #f2f2f2;
  }

  /* ################################ Estilos generales de la tabla ################################ */

  .sticky_footer_1 {
    position: sticky;
    bottom: 0;
    left: 0;
    background: #6c6c6c;
    color: #fff;
    z-index: 2;
  }

  .sticky_footer_2 {
    position: sticky;
    bottom: 0;
    left: 150px;
    background: #6c6c6c;
    color: #fff;
    z-index: 2;
  }

  .sticky_footer_contenido {
    position: sticky;
    z-index: 1 !important;
    bottom: 0;
    color: #fff;
    background: #6c6c6c;
  }

  .contenedor_tabla {
    width: 100%;
    height: 80%;
    /* border: 1px solid grey;
      padding: 10px; */
  }

  /* ################################ Estilos input ################################ */

  .ui-textbox {
    margin-bottom: 0rem;
  }

  /* Tabla vacía */
</style>
